module.exports = __webpack_public_path__ + "static/media/03-banner-02-tienda@2x.9942d7f4.jpg";